/** Default page size for admin list tables. */
export const LIST_PAGE_SIZE = 25;

export const pageCount = (total: number, pageSize = LIST_PAGE_SIZE): number =>
    Math.max(1, Math.ceil(Math.max(0, total) / pageSize));

export const slicePage = <T,>(items: T[], page: number, pageSize = LIST_PAGE_SIZE): T[] => {
    const start = (Math.max(1, page) - 1) * pageSize;

    return items.slice(start, start + pageSize);
};

/** Pick cover URL from a photos array (+ optional cover index). */
export const coverFromPhotos = (
    photos?: string[] | null,
    coverPhotoIndex?: number | null,
): string | undefined => {
    if (!photos?.length) return undefined;
    const idx =
        coverPhotoIndex != null && coverPhotoIndex >= 0 && coverPhotoIndex < photos.length
            ? coverPhotoIndex
            : 0;

    return photos[idx] || photos[0] || undefined;
};

export const totalFromMeta = (meta: unknown, fallback = 0): number => {
    const m = meta as { totalItems?: number; total?: number } | null | undefined;

    return Number(m?.totalItems ?? m?.total ?? fallback) || 0;
};
